module.exports = __webpack_public_path__ + "img/vuelogo.9a45fc76.svg";